// Full Impul storefront and its built-in checkout.
export const STORE_URL = "https://sales-practice-ready.impultienda.ar";
export const CHECKOUT_URL = "https://sales-practice-ready.impultienda.ar/checkout";

// Incoming campaign parameters forwarded to outbound store links.
export const TRACKING_PARAMS = [
  "utm_source",
  "utm_medium",
  "utm_campaign",
  "utm_content",
  "utm_term",
  "fbclid",
];
